import { createMutation } from 'react-query-kit';

import {
  AXIOS_INSTANCE,
  type BodyQuizEntryMapRes,
  ZepQuizApiError,
} from '@/api';

export const useGetTranslatedQuizSet = createMutation<
  BodyQuizEntryMapRes,
  {
    entryMapHashId: string;
    language: string;
    signal?: AbortSignal;
  }
>({
  mutationFn: async ({ entryMapHashId, language, signal }) => {
    const axiosResponse = await AXIOS_INSTANCE({
      url: `/quizsets/entry-map`,
      method: 'GET',
      params: {
        entryMapHashId,
        language,
      },
      signal,
    });

    if (axiosResponse.status === 202) {
      throw new TranslationError(202, 'The language is not processed yet');
    } else if (axiosResponse.status === 204) {
      throw new TranslationError(204, 'No translation data found');
    }

    return axiosResponse.data as BodyQuizEntryMapRes;
  },
  onError: error => {
    if (
      error instanceof ZepQuizApiError &&
      error.status === 'INVALID_TRANSLATION_LANGUAGE'
    ) {
      throw new TranslationError(400, 'Invalid translation language');
    }
  },
});

export class TranslationError {
  private _status: number;
  private _message?: string;

  constructor(status: number, message?: string) {
    this._status = status;
    this._message = message;
  }

  get status() {
    return this._status;
  }

  get message() {
    return this._message;
  }
}

export class TranslationAbortController extends AbortController {
  static readonly ABORT_REASON = 'Translation aborted';

  constructor() {
    super();
  }

  abort() {
    super.abort(TranslationAbortController.ABORT_REASON);
  }
}
